module.exports = __webpack_public_path__ + "static/media/packages.947869e1.svg";